import classNames from 'classnames';
import { type FC, useEffect } from 'react';

import SeoText from 'components/SeoText';
import { useConfig } from 'config';
import { AuthStatus, useClientProfile } from 'store';
import pushToDataLayer, { btag } from 'utils/dataLayer';
import useLayout from 'utils/layout';

import ActionButtons from './ActionButtons';
import CasinoGames from './CasinoGames';
import GetStarted from './GetStarted';
import WelcomeBanner from './WelcomeBanner';

import styles from './HomePage.module.scss';

const HomePage: FC = () => {
  const layout = useLayout();
  const welcomeBannerConfig = useConfig(
    'config.siteConfig.homePage.welcomeBanner',
  );
  const actionButtonsConfig = useConfig(
    'config.siteConfig.homePage.actionButtons',
  );
  const casinoGamesConfig = useConfig('config.siteConfig.homePage.casinoGames');
  const getStartedConfig = useConfig('config.siteConfig.homePage.getStarted');

  const [{ status }] = useClientProfile();

  useEffect(() => {
    pushToDataLayer('main_page_visit', btag);
  }, []);

  return (
    <div className={classNames(styles.wrapper, styles[layout])}>
      {welcomeBannerConfig?.enabled && (
        <WelcomeBanner
          titleSignedIn={welcomeBannerConfig.title_signedin}
          descriptionSignedIn={welcomeBannerConfig.description_signedin}
          titleSignedOut={welcomeBannerConfig.title}
          descriptionSignedOut={welcomeBannerConfig.description}
          image={welcomeBannerConfig.image}
        />
      )}
      {actionButtonsConfig?.enabled && (
        <ActionButtons buttons={actionButtonsConfig.items} />
      )}
      {casinoGamesConfig?.enabled && (
        <CasinoGames
          title={casinoGamesConfig.title}
          actionButton={casinoGamesConfig.actionButton}
        />
      )}
      {getStartedConfig?.enabled && status === AuthStatus.signedOut && (
        <GetStarted
          title={getStartedConfig.title}
          items={getStartedConfig.items}
          actionButton={getStartedConfig.actionButton}
        />
      )}
      <SeoText />
    </div>
  );
};

export default HomePage;
